import React from "react";
import { useHistory } from "react-router-dom";
import Page from "../../../_components/Layout/Page";
import Modal from "../../../_components/Modal";
import Row from "../../../_components/Layout/Row";
import Column from "../../../_components/Layout/Column";
import Text from "../../../_components/Text";
import Button from "../../../_components/Button";
import Toast from "../../../_components/Toast";
import { createBranchPlan, getPlans } from "../../../api/plans";
import AppContext from "../context";
import { formatCurrencyValue, getCookieByName } from "../../../utils";
import styled, { css } from "styled-components";
import SweetAlert from "react-bootstrap-sweetalert";

import * as colors from "../../../assets/_base/colors";
import IconButton from "../../../_components/IconButton";


const branch = getCookieByName('branch_owner_id')

const Line = styled.hr`
  background-color: ${colors.lightBlue} !important;
  width: 20px;
  height: 1px;
  border-radius: 20px;
`;

const Divider = styled.hr`
  background-color: ${colors.lightCyan};
`;
const breakpoint = "800px";
const ScrollContainer = styled.div`
  display: flex;
  flex-direction: row;
  overflow-y: hidden;
  overflow-x: hidden;
  scroll-behavior: smooth;
  user-select: none;
  @media (max-width: ${breakpoint}) {
    flex-direction: column;
  }
`;
const Header = styled.div`
  background-color: ${(props) => {
    if (props.plan === "89723c2c-64d1-40b4-9806-1aa433f91645" || props.plan === "f1818dc9-f799-4ad0-9dc1-37c33ce55265") {
      return colors.yellow;
    } else {
      return colors.lightBlue;
    }
  }}
  border-top-left-radius: 30px;
  border-top-right-radius: 30px;
`;
const Banner = styled.div`
  position: absolute;
  rotate: 30deg;
  top: 0;
  right: 0;
  margin-top: 30px;
  margin-right: -10px;
  padding-left: 10px;
  padding-right: 2px;
  padding-top: 3px;
  padding-bottom: 10px;
  background-color: ${colors.darkBlue};
  border-top-left-radius: 30px;
  border-bottom-left-radius: 30px;
  display: none;
  ${(props) => {
    if (props.notes_quantity === 10) {
      return css`
        display: block;
      `;
    }
  }}
`;
const Inner = styled.div`
  padding: 10px;
`;
const Footer = styled.div`
  background-color: ${(props) => {
    if (props.plan === "89723c2c-64d1-40b4-9806-1aa433f91645" || props.plan === "f1818dc9-f799-4ad0-9dc1-37c33ce55265") {
      return colors.yellow;
    } else {
      return colors.lightBlue;
    }
  }}
  border-bottom-left-radius: 30px;
  border-bottom-right-radius: 30px;
`;
const Item = styled.div`
  flex: 0 0 auto;
  min-height: 400px !important;
  margin: 10px;
  border-radius: 10px;
  -webkit-box-shadow: -14px 25px 21px 0px rgba(0, 0, 0, 0.24);
  -moz-box-shadow: -14px 25px 21px 0px rgba(0, 0, 0, 0.24);
  box-shadow: -14px 25px 21px 0px rgba(0, 0, 0, 0.24);
  border-top-left-radius: 30px;
  border-top-right-radius: 30px;
  border-bottom-left-radius: 30px;
  border-bottom-right-radius: 30px;

  ${(props) => {
    if (props.selected === true) {
      return css`
        border: 3px solid ${colors.success};
      `;
    }
    if (props.planId === "89723c2c-64d1-40b4-9806-1aa433f91645" || props.planId === "f1818dc9-f799-4ad0-9dc1-37c33ce55265") {
      return css``;
    }
  }}
`;
const Title = styled(Text)`
  padding-top: 10px;
  padding-bottom: 10px;
`;

const AutoScrollComponent = ({ items, onClick }) => {
  const containerRef = React.useRef(null);
  const [isDragging, setIsDragging] = React.useState(false);
  const [startX, setStartX] = React.useState(0);
  const [selected, setSelected] = React.useState("");
  const [isHovered, setIsHovered] = React.useState(false);

  const onDragStart = (e) => {
    setIsDragging(true);
    setStartX(e.pageX + containerRef.current.scrollLeft);
    containerRef.current.style.scrollBehavior = "auto"; // Desabilita o smooth scroll ao arrastar
  };

  const onDragEnd = () => {
    setIsDragging(false);
    setIsHovered(false)
    containerRef.current.style.scrollBehavior = "smooth"; // Reabilita o smooth scroll
  };

  const onDragMove = (e) => {
    if (isDragging) {
      const moveX = startX - (e.pageX + containerRef.current.scrollLeft);
      containerRef.current.scrollLeft += moveX;
      setStartX(e.pageX + containerRef.current.scrollLeft);
    }
  };

  const onItemClick = (item) => {
    setSelected(selected === item.id ? "" : item.id);
  };

  const handleMouseEnter = () => {
    setIsHovered(true);
  };

  React.useEffect(() => {
    const interval = setInterval(() => {
      if (containerRef.current && !isDragging && !selected && !isHovered) {
        const scrollWidth = containerRef.current.scrollWidth;
        const clientWidth = containerRef.current.clientWidth;
        const scrollLeft = containerRef.current.scrollLeft;
        if (scrollLeft + clientWidth >= scrollWidth) {
          containerRef.current.scrollTo({ left: 0 });
        } else {
          containerRef.current.scrollTo({ left: scrollLeft + clientWidth });
        }
      }
    }, 10000);

    return () => clearInterval(interval);
  }, [isDragging, isHovered]);

  return (
    <div>
      <div className="row justify-content-between">

        <i className="fas fa-arrow-left" style={{ fontSize: 25, cursor: "pointer" }} onClick={() => { containerRef.current.scrollTo({ left: 0 }) }} />
        <i className="fas fa-arrow-right" style={{ fontSize: 25, cursor: "pointer" }} onClick={() => { containerRef.current.scrollTo({ left: 1421 }) }} />


      </div>

      <ScrollContainer
        ref={containerRef}
        onMouseDown={onDragStart}
        onMouseMove={onDragMove}
        onMouseLeave={onDragEnd}
        onMouseUp={onDragEnd}
        onMouseEnter={handleMouseEnter}
      >
        {items.map((item, index) => (
          <Column xs="12" md="6" lg="4" xl="3">
            <Item key={index} selected={item.id === selected} planId={item.id}>
              <Header color="primary" plan={item.id}>
                <Title fontSize="md" align="center" color="white">
                  {item.name}
                </Title>
                <Banner notes_quantity={item.notes_quantity}>
                  <Text fontSize="1.1em" color="white">
                    Mais vendido!
                  </Text>
                </Banner>
              </Header>
              {item.id === "89723c2c-64d1-40b4-9806-1aa433f91645" || item.id === "f1818dc9-f799-4ad0-9dc1-37c33ce55265" ? (
                <Text align="center">
                  * Você tem até um ano ou até vencer o seu certificado digital
                  para utilizá-las
                </Text>
              ) : (
                <Text></Text>
              )}

              <Inner onClick={() => onItemClick(item)}>
                {item.description.split(";").map((description, idx) => {
                  const [item, allow] = description.split("=");
                  return (
                    <React.Fragment>
                      <Text fontSize="1.1em" color="primary">
                        <i
                          className={`fas fa-${allow === "S" ? "check" : "ban text-danger"
                            }`}
                        ></i>{" "}
                        {item}
                      </Text>
                      <Divider />
                    </React.Fragment>
                  );
                })}
                {item.id === "89723c2c-64d1-40b4-9806-1aa433f91645" || item.id === "f1818dc9-f799-4ad0-9dc1-37c33ce55265" ? (
                  <Text align="center">
                    RENOVANDO SEU CERTIFICADO CONOSCO, VOCÊ TERÁ MAIS NOTAS POR
                    MAIS UM ANO.
                  </Text>
                ) : (
                  <Text align="center">
                    NÃO INCLUI CERTIFICADO DIGITAL (A1) GRÁTIS
                  </Text>
                )}
              </Inner>
              <Footer plan={item.id} color="primary">
                <div className="d-flex justify-content-center py-2">
                  <Button as="text" onClick={() => onClick(item)}>
                    {item.id === "7945dc1a-1722-43db-a92c-59c8c23346e9" ? (
                      <Text fontSize="md" color="white" align="center">
                        Negociar com um consultor
                      </Text>
                    ) : item.free_plan === true ? (
                      <Text fontSize="md" color="white" align="center">
                        Adquirir gratuitamente
                      </Text>
                    ) : (
                      <Text fontSize="md" color="white" align="center">
                        Adquirir por {formatCurrencyValue(parseFloat(item.price))} /mês
                      </Text>
                    )}

                  </Button>
                </div>
              </Footer>
            </Item>
          </Column>
        ))}
      </ScrollContainer>
    </div>

  );
};
export default (props) => {
  const ref = React.useRef(null);
  const history = useHistory();
  const context = React.useContext(AppContext);
  const [showModalInfo, setShowModalInfo] = React.useState(true);
  const [plans, setPlans] = React.useState([]);
  const [selectedPlan, setSelectedPlan] = React.useState({});

  const [loading, setLoading] = React.useState(false);
  const [success, setSuccess] = React.useState(false);
  const [toast, setToast] = React.useState({
    show: false,
    message: "",
    type: "",
  });


  function openModalSelectPlan(plan) {
    const isNegotiation = plan.id === "7945dc1a-1722-43db-a92c-59c8c23346e9"
    if (isNegotiation) {
      window.open(
        'https://wa.me/5511966466526?text=Olá!,+quero+negociar+um+plano+entre+31+e+99+notas+no+Easygestor',
        "_blank"
      )
      return
    }
    setSelectedPlan(plan)
  }



  function closeModalSelectPlan() {
    if (loading) {
      return
    }
    setSelectedPlan({});
  }


  function onCreate() {
    setLoading(true);
    setToast({});
    createBranchPlan({ plan: selectedPlan.id })
      .then((resp) => {
        let updatedBranch = JSON.parse(localStorage.getItem("easygestorweb_current_branch") || {})
        updatedBranch["branch_plan"] = resp
        updatedBranch["branch_plan"]["is_fiscal"] = true
        window.localStorage.setItem("easygestorweb_current_branch", JSON.stringify(updatedBranch))
        setSelectedPlan(resp)
        setSuccess(true)
      })
      .catch((error) => {
        setLoading(false);
        if (error.response) { }
        if (error.iugu_error) {
          setToast({
            show: true,
            message: `Não foi possível criar sua assinatura. Erro: ${error.iugu_error}`,
            type: "error",
          });
        }
        if (error.partner_error) {
          setToast({
            show: true,
            message: `Não foi possível criar sua assinatura. Erro: ${error.partner_error}`,
            type: "error",
          });
        }
        if (error.invoice_pending) {
          setToast({
            show: true,
            message: (
              <div>
                Você possui faturas pendentes, para consultar suas faturas,
                clique no botão abaixo.
                <a className="btn btn-primary" href={"/plan/branch-invoices"}>
                  Vizualizar faturas
                </a>
              </div>
            ),
            type: "error",
          });
        }
        if (error.plan_error) {
          setToast({
            show: true,
            message: (
              <div>
                Sua empresa não possui mais créditos para assinatura gratuita.
                Escolha outro plano ou fale com o suporte.{" "}
                <a
                  className="btn btn-primary text-center"
                  target="_blank"
                  href="https://api.whatsapp.com/send?phone=+5511966466526&text=Ol%C3%A1.%20Minha%20empresa%20n%C3%A3o%20possui%20mais%20cr%C3%A9ditos%20para%20assinatura%20gratuita.%20Preciso%20de%20ajuda."
                >
                  Solicitar suporte
                </a>
              </div>
            ),
            type: "error",
          });
        }
      });
  }

  function onFinalize() {
    let href = ""
    if (selectedPlan.free_plan == true) {
      href = "/digital-certificate"
    } else {
      href = "/plan/branch-invoices"
    }

    window.location.href = href

  }

  function init() {
    const branchId = getCookieByName("branch_owner_id");

    if (!branchId || branchId === "09ef7488-d439-40da-b384-5ccde14ffe8a") {
      history.push("/branches/create");
    } else {
      getPlans().then((pls) => setPlans(pls));
    }
  }
  React.useEffect(init, [ref.current, context.currentBranch]);

  return (
    <Page ref={ref}>
      <Row>
        <Column col="12">
          <Text fontSize="lg" align="center" color="primary">
            Escolha seu Plano Ideal
          </Text>
        </Column>
      </Row>
      <AutoScrollComponent onClick={openModalSelectPlan} items={plans} />

      <Modal
        title={`Assinatura ${selectedPlan.name}`}
        show={selectedPlan.id}
        onHide={closeModalSelectPlan}
      >
        {selectedPlan.id === "89723c2c-64d1-40b4-9806-1aa433f91645" || selectedPlan.id === "f1818dc9-f799-4ad0-9dc1-37c33ce55265" ? (
          <Text color="primary" fontSize="md" className="py-3">
            Prezado(a) cliente, você está prestes a adquirir o plano{" "}
            {selectedPlan.name} para sua empresa.
          </Text>
        ) : (
          <React.Fragment>
            <Text color="primary" fontSize="md">
              Prezado(a) cliente, você está prestes a adquirir o plano{" "}
              {selectedPlan.name} para sua empresa no valor de{" "}
              {formatCurrencyValue(parseFloat(selectedPlan.price))}/mês.
            </Text>
            <Text className="py-4" color="danger" fontSize="md">
              Atenção! Após confirmação, não será mais possível realizar emissão
              de notas enquanto o novo plano estiver com a fatura pendente.
              Após pagamento, a ativação será liberada automaticamente.
            </Text>
            <Text className="mb-2" color="primary">
              Formas de pagamento: PIX e cartões de crédito (American Express,
              Mastercard, Visa, Elo)
            </Text>
          </React.Fragment>
        )}

        <Text align="center" color="primary" fontSize="md">
          Clique no botão abaixo para confirmar a assinatura.
        </Text>

        <div className="d-flex justify-content-center pt-5">
          <Button disabled={loading} onClick={onCreate}>
            Confirmar
          </Button>
        </div>
      </Modal>

      <SweetAlert
        show={showModalInfo}
        type={'info'}
        showCancel={false}
        showConfirm={false}
        onCancel={null}
        onConfirm={null}
        title={
          <div>
            <div className="h2 text-danger">Importante</div>
          </div>
        }
      >

        <div style={{ textAlign: 'left', color: '#545151' }}>

          <p>
            Nos estados de <strong style={{ color: '#545151', fontWeight: 'bold' }}>AL e PA e RJ, o MEI</strong> não é permitido a emitir NF-e (nota fiscal de produto).
            Mas caso você seja <strong style={{ color: '#545151', fontWeight: 'bold' }}>MEI</strong> no estado do <strong style={{ color: '#545151', fontWeight: 'bold' }}>Rio de Janeiro</strong>,
            você <strong style={{ color: '#545151', fontWeight: 'bold' }}>pode realizar a emissão de NFC-e</strong> (cupom fiscal), desde que seja gerado o código CSC.
          </p>

          <p>
            Nos estados de <strong style={{ color: '#545151', fontWeight: 'bold' }}>MG e RS</strong>, existem particularidades para liberação da emissão de
            <strong style={{ color: '#545151', fontWeight: 'bold' }}> NF-e para quem é MEI</strong>.
          </p>

          <p>
            <a href="https://wa.me/5511966466526?" target="_blank" style={{ color: '#5e17eb', textDecoration: 'underline' }}>
              Verifique com o nosso Suporte técnico.
            </a>
          </p>

          <p><strong style={{ color: '#545151', fontWeight: 'bold' }}>Requisitos mínimos para emissão de NF-e no Easygestor:</strong></p>
          <ul>
            <li>
              <strong style={{ color: '#545151', fontWeight: 'bold' }}>Inscrição Estadual</strong> (
              <a href="https://www.youtube.com/watch?v=KTHdFrTi380" target="_blank" style={{ color: '#2f8dfc', textDecoration: 'underline' }}>
                Tudo sobre inscrição Estadual
              </a>
              );
            </li>
            <li>
              <strong style={{ color: '#545151', fontWeight: 'bold' }}>Certificado Digital modelo A1</strong> (
              <a href="http://bit.ly/comprar-certificad-eg-web-up" target="_blank" style={{ color: '#2f8dfc', textDecoration: 'underline' }}>
                Oferta com desconto
              </a>
              );
            </li>
            <li>
              Caso você possua Certificado A3,
              <a href="https://wa.me/5511966466526?" target="_blank" style={{ color: '#2f8dfc', textDecoration: 'underline' }}> fale com o suporte técnico</a>
            </li>
            <li>
              <strong style={{ color: '#545151', fontWeight: 'bold' }}>Credenciamento na SEFAZ</strong> do seu estado.
            </li>
          </ul>

        </div>

        <div className="d-flex justify-content-center">
          <div>
            <Line />

            <IconButton onClick={() => setShowModalInfo(false)} icon="times text-danger" />

          </div>
        </div>
      </SweetAlert>

      <Modal title="Assinatura criada!" show={success}>
        <Text color="primary" align="center" fontSize="md">
          Prezado(a) cliente, seja bem-vindo(a) ao Easygestor!
        </Text>
        {selectedPlan.id === "89723c2c-64d1-40b4-9806-1aa433f91645" || selectedPlan.id === "f1818dc9-f799-4ad0-9dc1-37c33ce55265" ? (
          <React.Fragment>
            <Text color="primary" className="py-2" fontSize="md">
              Seu plano gratuito foi criado com sucesso! E você acabou de
              adquirir gratuitamente a emissão de {selectedPlan.notes_quantity}{" "}
              notas fiscais.
            </Text>
            <Text color="primary" className="py-2" fontSize="md">
              Você tem até um ano ou até vencer o seu certificado digital para
              utilizá-las.
            </Text>
            <Text color="primary" className="py-2" fontSize="md">
              Renovando seu certificado através você terá mais{" "}
              {selectedPlan.notes_quantity} notas por mais um ano.
            </Text>
          </React.Fragment>
        ) : (
          <React.Fragment>
            <Text color="primary" fontSize="md" className="py-2">
              Informamos que, o cancelamento da sua assinatura será deferido, se
              somente, não existir nenhuma pendência no nosso sistema
              financeiro.
            </Text>
            <Text color="primary" fontSize="md" className="py-2">
              Informamos também que, o simples fato de parar de pagar/usa o
              Sistema, o mesmo não anula cobranças em atraso pendentes, nem gera
              o cancelamento automático do seu Plano mensal de assinatura.
            </Text>
            <Text color="primary" fontSize="md" className="py-2">
              Em caso de dúvidas, ou para regularizar seu Plano, pedimos por
              gentileza que entre em contato com o nosso suporte técnico.
            </Text>
          </React.Fragment>
        )}
        <div className="d-flex justify-content-center pt-5">
          <Button onClick={onFinalize}>
            Declaro que li e concordo com o texto acima.
          </Button>
        </div>
      </Modal>
      <Toast show={toast.show} message={toast.message} type={toast.type} />
    </Page>
  );
};



// WEBPACK FOOTER //
// ./src/views/AppViews/Plans/index.jsx